import Vue from 'vue'
import VueRouter from 'vue-router'
import Menus from '@/pages/menus/index'
import InvestmentDecision from '@/pages/investmentDecision/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Menus',
    component: Menus
  },
  {
    path: '/investmentDecision',
    name: 'InvestmentDecision',
    component: InvestmentDecision,
    meta: {
      title: 'CRIC投资决策产品'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (_hmt) {
		if (to.path) {
			_hmt.push(['_trackPageview', '/#' + to.fullPath]);
		}
  }

  document.title = to.meta && to.meta.title || 'CRIC产品线'
  next()
})

export default router
